import { render } from "./orcamento-editar.vue?vue&type=template&id=53ad285a"
import script from "./orcamento-editar.vue?vue&type=script&lang=js"
export * from "./orcamento-editar.vue?vue&type=script&lang=js"

import "./orcamento-editar.vue?vue&type=style&index=0&id=53ad285a&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__